import { render, staticRenderFns } from "./recordDetail.vue?vue&type=template&id=2911afbe&scoped=true&"
import script from "./recordDetail.vue?vue&type=script&lang=js&"
export * from "./recordDetail.vue?vue&type=script&lang=js&"
import style0 from "./recordDetail.vue?vue&type=style&index=0&id=2911afbe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2911afbe",
  null
  
)

export default component.exports